import { getProductTypeList } from "actions/productType";
import { getPublisherList } from "actions/publisher";
import { showAlert } from "components/Common/commonFunctions";
import SearchableDropdown from "components/DropDown/SearchableDropdown";
import DynamicFormModal from "components/Modal/Form";
import {
  getStatusBadge,
  revenueProgressFormatter,
} from "components/Table_Details/Table_Details";
import ReactBsTable from "components/Tables/ReactBsTable";
import moment from "moment";
import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Container,
  Badge,
  UncontrolledTooltip,
  Col,
  Row,
  Button,
  Card,
} from "reactstrap";
import { DATE_RANGE_OPTIONS } from "variables/constants";
import { marginTabFormFields } from "variables/formFields";
import NotificationAlert from "react-notification-alert";
import { getDealList } from "actions/deal";
import { marginManagementList } from "actions/marginManagement";
import { createMarginManagement } from "actions/marginManagement";
import { updateMarginManagement } from "actions/marginManagement";
import { getMarginManagementData } from "actions/marginManagement";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getProductTypeListByPublisherID } from "actions/productType";

const sortFieldMap = {
  publisher_name: "CompanyName",
  deal_name: "DealName",
  deal_type: "DealType",
  product_type: "ProductTypeName",
  adjustmentType: "AdjustmentType",
  startDate: "StartDate",
  endDate: "EndDate",
  percentage: "Percentage",
};

const Margin_Management = () => {
  const [marginData, setMarginData] = useState({
    data: [],
    totalRecords: 0,
  });
  const notificationAlertRef = useRef(null);
  const [showAddMdoal, setshowAddMdoal] = useState({
    formType: "Create New Margin",
    show: false,
  });

  const [formState, setFormState] = useState({
    values: {},
    errors: {},
  });
  const [dropDownData, setDropDownData] = useState({
    publisherData: [],
    productTypeData: [],

    dealData: [],
  });
  const [publisherOptions, setPublisherOptions] = useState([]);
  const [dealOptions, setDealOptions] = useState([]);
  const [pageNum, setPageNum] = useState(1);
  const [selected, setSelected] = useState(null);
  const [showLoader, setshowLoader] = useState(false);
  const [dropDownOtherData, setdropDownOtherData] = useState({
    publisherData: { pageNum: 1, searchString: "", totalRecords: 0 },
    dealData: { pageNum: 1, searchString: "", totalRecords: 0 },

    productTypeData: { pageNum: 1, searchString: "", totalRecords: 0 },
  });
  const [sortConfig, setSortConfig] = useState({
    dataField: "",
    sortField: "",
    sortOrder: "",
  });
  const [filters, setFilters] = useState({
    deal_name: "",
    publisher_name: "",
    product_type: "",
    date_range: "",
    start_date: "",
    end_date: "",
    status: "",
    filterParams: [],
  });

  const notify = (type, message) => {
    notificationAlertRef.current.notificationAlert({
      place: "tr",
      message: <div>{message}</div>,
      type,
      icon: "tim-icons icon-bell-55",
      autoDismiss: 5,
    });
  };

  const isEditMode = !!selected;

  const getPublisherOptions = async (searchString = "") => {
    try {
      const res = await getPublisherList(1, [], searchString);
      const options =
        res?.code === 200
          ? (res?.data?.Publisher || []).map((item) => ({
              label: item?.companyName || "",
              value: item?.ID || "",
            }))
          : [];
      setPublisherOptions(options);
    } catch (error) {
      console.error("Failed to load publisher options", error);
    }
  };

  const getDealOptions = async (searchString = "") => {
    try {
      const filterParams = [];

      if (filters.product_type) {
        filterParams.push({
          field: "ProductTypeID",
          condition: "eq",
          filterValues: [String(filters.product_type)],
        });
      }

      if (filters.publisher_name) {
        filterParams.push({
          field: "PublisherID",
          condition: "eq",
          filterValues: [String(filters.publisher_name)],
        });
      }
      const res = await getDealList(
        0,
        JSON.stringify(filterParams),
        searchString,
      );
      const options =
        res?.code === 200
          ? (res?.data?.Deal || []).map((item) => ({
              label: item?.name || "",
              value: item?.name || "",
            }))
          : [];
      setDealOptions(options);
    } catch (error) {
      console.error("Failed to load deal options", error);
    }
  };

  useEffect(() => {
    getPublisherOptions();
    getDealOptions();
  }, []);

  useEffect(() => {
    getDealOptions();
  }, [filters.publisher_name, filters.product_type]);

  const handlePublisherSearch = useCallback(({ query }) => {
    getPublisherOptions(query);
  }, []);

  const handleDealSearch = useCallback(({ query }) => {
    getDealOptions(query);
  }, []);

  // REMOVED separate sort useEffect - combined with main data fetching

  //Sort Function
  const handleSortChange = (dataField, sortOrder) => {
    const mappedSortField = sortFieldMap[dataField] || dataField;
    setSortConfig({ dataField, sortField: mappedSortField, sortOrder });
    // setPageNum(1); // Reset to first page when sorting changes
  };

  // ===> columns is used for to show the columns on Margin management List.
  const columns = [
    {
      dataField: "publisher_name",
      text: "Publisher",
      sort: true,
      formatter: (cell, row) => row?.publisher?.companyName || "-",
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "deal_name",
      text: "Deal Name",
      formatter: (cell, row) => row?.deal?.dealName || "-",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "deal_type",
      text: "Deal Type",
      formatter: (cell, row) => row?.deal?.dealType || "-",
    },
    {
      dataField: "product_type",
      text: "Product Type",
      formatter: (cell, row) => row?.productType?.name || "-",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "adjustmentType",
      text: "Adjustment Type",
      formatter: (cell, row) => row?.adjustmentType || "-",
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "startDate",
      text: "Start Date",
      formatter: (cell) => moment(cell).format("DD MMM YYYY"),
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      dataField: "percentage",
      text: "Percent",
      formatter: (cell) => revenueProgressFormatter(String(cell)),
      sort: true,
      sortCaret: (order) => {
        if (!order) {
          return (
            <span className="sort-caret" style={{ marginLeft: "8px" }}>
              <i className="fa fa-sort" />
            </span>
          );
        }
        return order === "asc" ? (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-up" />
          </span>
        ) : (
          <span className="sort-caret" style={{ marginLeft: "8px" }}>
            <i className="fa fa-sort-down" />
          </span>
        );
      },
    },
    {
      text: "Actions",
      dataField: "actions",
      headerAlign: "center",
      formatter: (cell, row) => {
        const rowId = row?.ID;
        return (
          <div
            key={rowId}
            style={{ display: "flex", justifyContent: "center", gap: "12px" }}
          >
            <div>
              <a
                className="table-action table-action-info"
                id={`tooltipEdit${rowId}`}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditMargin(row);
                }}
              >
                <i className="fas fa-edit" />
              </a>
              <UncontrolledTooltip delay={0} target={`tooltipEdit${rowId}`}>
                Edit Margin
              </UncontrolledTooltip>
            </div>
          </div>
        );
      },
    },
  ];

  const openAddModal = () => {
    setSelected(null);
    setshowAddMdoal({
      formType: "Create New Margin",
      show: !showAddMdoal.show,
    });
    setFormState({
      values: { status: true, margin_action: "REDUCE" },
      errors: {},
    });
  };

  useEffect(() => {
    if (showAddMdoal) {
      fetchPublishers();
    }
  }, [showAddMdoal]);

  const handleManageModal = () => {
    setFormState({
      values: {},
      errors: {},
    });
    setshowAddMdoal(!showAddMdoal);
  };

  const handleInputChange = (e) => {
    const name = e?.target?.name || e?.name;
    let value = e?.target?.value ?? e?.value;
    setFormState((prev) => {
      const field = marginTabFormFields(
        dropDownData.productTypeData,
        dropDownData.publisherData,
        dropDownData.productTypeData,
      ).find((f) => f.name === name);
      const updatedValues = { ...prev.values };
      const errors = { ...prev.errors };

      if (field?.type === "number") {
        if (value === "") {
          updatedValues[name] = "";
          errors[name] = "";
        } else if (!/^-?\d*$/.test(value)) {
          return prev;
        } else if (Number(value) > 100) {
          errors[name] = `${field.label} cannot be greater than 100`;
          return {
            ...prev,
            errors,
          };
        } else {
          updatedValues[name] = value;
          errors[name] = "";
        }
      } else {
        updatedValues[name] = value;
        errors[name] = "";
      }
      if (name === "publisher_name" && value != "") {
        updatedValues.deal_name = "";
        getDealsBypublisherId(value);
      }

      return {
        values: updatedValues,
        errors,
      };
    });
  };

  const validateForm = (fields, values) => {
    const errors = {};

    fields.forEach((field) => {
      const value = values[field.name];

      if (field.required && (value === undefined || value === "")) {
        errors[field.name] = `${field.label} is required`;
        return;
      }

      if (
        (field.type === "number" || field.inputType === "number") &&
        value !== undefined &&
        value !== ""
      ) {
        if (field.max !== undefined && Number(value) > field.max) {
          errors[field.name] = `${field.label} cannot be greater than ${field.max}`;
        }
      }

      if (values.margin_percent === undefined || values.margin_percent === "") {
        errors.margin_percent = `Margin Percentage is required`;
        return;
      }

      if (values.margin_percent !== undefined && values.margin_percent !== "") {
        if (values.margin_percent > 100 || values.margin_percent < 0) {
          errors.margin_percent = `Margin Percentage cannot be less than 0 or greater than 100`;
        }
      }
    });
    return errors;
  };

  const getDropDownData = async () => {
    try {
      const filterParams = [];
      if (filters.publisher_name) {
        filterParams.push({
          field: "PublisherID",
          condition: "eq",
          filterValues: [String(filters.publisher_name)],
        });
      }
      const [productTypeRes] = await Promise.all([
       
     
           filterParams.length > 0 ?
            getProductTypeListByPublisherID(filters.publisher_name)
             :
            getProductTypeList(
                 0,
                 `[{"field":"Status","condition":"eq","filterValues":["ACTIVE"]}]`,
                 ""
               )
             
      ]);

      
      const productTypeData =
        productTypeRes?.code === 200
          ? (productTypeRes?.data?.ProductType || []).map((item) => ({
              label: item?.name || "",
              value: item?.ID,
            }))
          : [];

    
      setDropDownData((prev) => ({
        ...prev,
        productTypeData: productTypeData,
       
      }));
      setdropDownOtherData({
       
        productTypeData: {
          totalRecords: productTypeRes?.data?.totalRecords,
          pageNum: 1,
          searchString: "",
        },
        publisherData: {
          totalRecords: 0,
          pageNum: dropDownOtherData?.publisherData.pageNum,
          searchString: "",
        },
        dealData: {
          totalRecords: 0,
          pageNum: dropDownOtherData?.dealData.pageNum,
          searchString: "",
        },
      });
    } catch (error) {
      console.error("Dropdown API error:", error?.message);
    }
  };

  // COMBINED useEffect - fetching data with sorting and pagination
  const getMarginMangementList = async () => {
    try {
      setshowLoader(true);
      const res = await marginManagementList(
        pageNum,
        filters.filterParams,
        "",
        sortConfig.sortField,
        sortConfig.sortOrder,
      );
      if (res.code === 200) {
        setMarginData({
          data: res?.data.MarginRule,
          totalRecords: res.data.totalRecords,
        });
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      console.error("Error fetching margin list:", error);
    } finally {
      setshowLoader(false);
    }
  };

  // SINGLE useEffect for data fetching with all dependencies
  useEffect(() => {
    getMarginMangementList();
  }, [pageNum, filters.filterParams, sortConfig.sortField, sortConfig.sortOrder]);

  useEffect(() => {
    getDropDownData();
  }, [filters.publisher_name]);

  const getDealsBypublisherId = async (publisherId) => {
    try {
      const res = await getDealList(
        dropDownData.dealData.pageNum,
        JSON.stringify([
          {
            field: "PublisherID",
            condition: "eq",
            filterValues: [String(publisherId)],
          },
        ]),
        dropDownData.dealData.searchString,
      );
      const dealData =
        res?.code === 200
          ? (res?.data?.Deal || []).map((item) => ({
              label: item?.name || "",
              value: item?.ID,
            }))
          : [];
      setDropDownData((prev) => ({
        ...prev,
        dealData: dealData,
      }));
      setdropDownOtherData((prev) => ({
        ...prev,
        dealData: {
          totalRecords: res?.data?.totalRecords,
          pageNum: dropDownOtherData?.dealData.pageNum,
          searchString: "",
        },
      }));
    } catch (error) {}
  };

  const fetchPublishers = async () => {
    try {
      const publisherRes = await getPublisherList();
      const publisherData =
        publisherRes?.code === 200
          ? (publisherRes?.data?.Publisher || []).map((item) => ({
              label: item?.companyName || "",
              value: item?.ID,
            }))
          : [];
      setDropDownData((prev) => ({
        ...prev,
        publisherData: publisherData,
      }));

      setdropDownOtherData((prev) => ({
        ...prev,
        publisherData: {
          totalRecords: publisherRes?.data?.totalRecords,
          pageNum: dropDownOtherData?.publisherData.pageNum,
          searchString: "",
        },
      }));
    } catch (error) {}
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setshowLoader(true);
    try {
      const errors = validateForm(
        marginTabFormFields(
          dropDownData.productTypeData,
          dropDownData.publisherData,
          dropDownData.dealData,
        ),
        formState.values,
      );

      if (Object.keys(errors).length) {
        setFormState((prev) => ({
          ...prev,
          errors,
        }));
        setshowLoader(false);
        return;
      }
      let date = moment(formState?.values?.start_date).format("DD/MM/YYYY");

      let payload = !isEditMode
        ? {
            publisherID: formState?.values?.publisher_name,
            dealID: formState?.values.deal_name,
            adjustmentType: formState?.values.adjustment_types,
            percentage: Number(formState?.values?.margin_percent),
            startDate: date,
            status: "ACTIVE",
            action: formState?.values?.margin_action
              ? formState?.values?.margin_action
              : null,
          }
        : {
            adjustmentType: formState?.values.adjustment_types,
            percentage: Number(formState?.values?.margin_percent),
            status: "ACTIVE",
            action: formState?.values?.margin_action
              ? formState?.values?.margin_action
              : null,
          };

      const res = !isEditMode
        ? await createMarginManagement(payload)
        : await updateMarginManagement(selected?.ID, payload);
      if (res.code === 200) {
        notify("success", res?.message);
        getMarginMangementList();
        setshowAddMdoal({
          formType: "Create New Margin",
          show: false,
        });
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {
      notify("danger", "Something went wrong");
    } finally {
      setshowLoader(false);
    }
  };

  const getMarginDataById = async (row) => {
    try {
      const res = await getMarginManagementData(row.ID);
      if (res.code === 200) {
        let data = res?.data;
        setFormState({
          values: {
            publisher_name: data.publisher?.publisherID,
            deal_name: data?.deal.dealID,
            adjustment_types: data?.adjustmentType,
            productType: data?.productType?.ID,
            margin_percent: String(data?.percentage),
            start_date: data?.startDate,
            status: data.status === "ACTIVE" ? true : false,
            margin_action: data?.action,
          },
          errors: {},
        });
        getDealsBypublisherId(data.publisher?.publisherID);
        getProductTypeListByPublisherID(filters.publisher_name);
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {}
  };

  const handleEditMargin = (row) => {
    setSelected(row);
    getMarginDataById(row);
    setshowAddMdoal({
      formType: "Edit Margin",
      show: true,
    });
  };

  const handleStatusToggle = async (row) => {
    const isActive = row.status === "ACTIVE";
    const res = await getMarginManagementData(row?.ID);
    let data = res?.data;

    showAlert({
      title: `Are you sure you want to ${
        isActive ? "inactivate" : "activate"
      } this Margin?`,
      message: `Margin "${row.adjustmentType}" will be ${
        isActive ? "inactive" : "active"
      }.`,
      type: "warning",
      confirmStyle: "secondary",
      cancelStyle: "btn btn-primary btn-gradient-primary",
      confirmText: "Yes",
      cancelText: "Cancel",
      onConfirm: () => confirmStatus(data),
      onCancel: () => {},
    });
  };

  const confirmStatus = async (data) => {
    try {
      let payload = {
        publisherID: data.publisher?.publisherID,
        dealID: data?.deal.dealID,
        adjustmentType: data?.adjustmentType,
        productTypeID: data?.productType?.ID,
        percentage: data?.percentage,
        startDate: data?.startDate,
        action: data?.action,
        status: data.status === "ACTIVE" ? "INACTIVE" : "ACTIVE",
      };
      const res = await updateMarginManagement(data?.ID, payload);
      if (res.code === 200) {
        notify("success", res?.message);
        getMarginMangementList();
        setshowAddMdoal({
          formType: "Create New Margin",
          show: false,
        });
      } else {
        const message = Array.isArray(res?.message)
          ? res?.message[0]?.Msg
          : res?.message || "Something went wrong";
        notify("danger", message);
      }
    } catch (error) {}
  };

  const showCustomDateInputs = (name, value) => {
    const today = moment().format("YYYY-MM-DD");

    if (value === "Custom Range") {
      setFilters((prev) => ({
        ...prev,
        date_range: value,
        start_date: "",
        end_date: "",
      }));
      return;
    }

    let months = 0;
    if (value === "Last 1 Month") months = 1;
    if (value === "Last 3 Month") months = 3;
    if (value === "Last 6 Month") months = 6;
    if (value === "Last 12 Month") months = 12;

    const startDate = moment().subtract(months, "months").format("YYYY-MM-DD");

    setFilters((prev) => ({
      ...prev,
      date_range: value,
      start_date: startDate,
      end_date: today,
    }));
  };

  const handleFilterChange = (key, value) => {
    setFilters((prev) => {
      if (key === "start_date") {
        const startDate = value;
        const endDate = prev.end_date;

        if (endDate && new Date(startDate) <= new Date(endDate)) {
          return {
            ...prev,
            start_date: startDate,
          };
        }

        return {
          ...prev,
          start_date: startDate,
          end_date: "",
        };
      }

      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const buildFilterParams = () => {
    const filterParams = [];

    if (filters?.product_type !== "") {
      filterParams.push({
        field: "ProductTypeID",
        condition: "eq",
        filterValues: [String(filters?.product_type)],
      });
    }
    if (filters?.publisher_name !== "") {
      filterParams.push({
        field: "PublisherID",
        condition: "in",
        filterValues: [String(filters?.publisher_name)],
      });
    }

    if (filters?.deal_name !== "") {
      filterParams.push({
        field: "DealName",
        condition: "like",
        filterValues: [filters?.deal_name],
      });
    }

    if (filters?.start_date !== "" && filters?.end_date !== "") {
      filterParams.push({
        field: "CreatedAt",
        condition: "btw",
        filterValues: [filters?.start_date, filters?.end_date],
      });
    }

    return filterParams.length > 0 ? JSON.stringify(filterParams) : "";
  };

  const isAnyFilterApplied = (filters) => {
    return Object.entries(filters).some(([key, value]) => {
      if (key === "filterParams") {
        return Array.isArray(value) && value.length > 0;
      }
      return value !== "" && value !== null && value !== undefined;
    });
  };

  const handleSearch = () => {
    if (!isAnyFilterApplied(filters)) return;
    const newfilterParams = buildFilterParams();

    setFilters({
      ...filters,
      filterParams: newfilterParams,
    });
    if (pageNum !== 1) setPageNum(1);
  };

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleReset = () => {
    if (!isAnyFilterApplied(filters)) return;

    setFilters({
      deal_name: "",
      publisher_name: "",
      product_type: "",
    
      date_range: "",
      start_date: "",
      end_date: "",
      status: "",
      filterParams: [],
    });
  };

  const filterSection = () => {
    return (
      <>
        <Row className="align-items-center">
          <Col md={2}>
            <SearchableDropdown
              name="publisher_name"
              options={publisherOptions}
              placeholder="Select Publisher"
              value={filters.publisher_name}
              onChange={(e) =>
                handleFilterChange("publisher_name", e.target.value)
              }
              onSearch={handlePublisherSearch}
              isSearchable={true}
            />
          </Col>
          <Col md={2}>
            <SearchableDropdown
              options={dropDownData?.productTypeData}
              placeholder="Product Type"
              value={filters.product_type}
              onChange={(e) =>
                handleFilterChange("product_type", e.target.value)
              }
              isSearchable={false}
            />
          </Col>
          <Col md={2}>
            <SearchableDropdown
              name="deal_name"
              options={dealOptions}
              placeholder="Deal Name"
              value={filters.deal_name}
              onChange={(e) => handleFilterChange("deal_name", e.target.value)}
              onSearch={handleDealSearch}
              isSearchable={true}
            />
          </Col>
        </Row>

        <Row className="mt-2">
          <>
            <Col md={2}>
              <SearchableDropdown
                options={DATE_RANGE_OPTIONS}
                placeholder="Date Range"
                value={filters.date_range}
                onChange={(e) =>
                  showCustomDateInputs("date_range", e.target.value)
                }
                isSearchable={false}
              />
            </Col>
            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.start_date ? new Date(filters.start_date) : null
                  }
                  onChange={(date) =>
                    handleFilterChange(
                      "start_date",
                      date ? formatDate(date) : "",
                    )
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="Start Date"
                  className="form-control custom-datepicker"
                  disabled={filters.date_range !== "Custom Range"}
                />
                <i className="ni ni-calendar-grid-58 text-muted calendar-icon" />
              </div>
            </Col>

            <Col md={2}>
              <div className="datepicker-wrapper">
                <DatePicker
                  selected={
                    filters.end_date ? new Date(filters.end_date) : null
                  }
                  onChange={(date) =>
                    handleFilterChange("end_date", date ? formatDate(date) : "")
                  }
                  dateFormat="dd MMM yyyy"
                  placeholderText="End Date"
                  className="form-control custom-datepicker"
                  disabled={
                    filters.date_range !== "Custom Range" || !filters.start_date
                  }
                  minDate={
                    filters.start_date
                      ? new Date(filters.start_date)
                      : undefined
                  }
                />
                <i className="ni ni-calendar-grid-58 text-muted calendar-icon" />
              </div>
            </Col>
          </>
          <Col md={4}>
            <Button
              onClick={handleSearch}
              disabled={!isAnyFilterApplied(filters)}
              className="filter-btn-gradient-primary btn-md responsive"
            >
              Search
            </Button>

            <Button
              className="secondary"
              disabled={!isAnyFilterApplied(filters)}
              onClick={handleReset}
            >
              Reset
            </Button>
          </Col>
        </Row>
      </>
    );
  };

  return (
    <>
      <div className="rna-container">
        <NotificationAlert ref={notificationAlertRef} />
      </div>
      <Container className="mt--6" fluid>
        <Card>
          <ReactBsTable
            title="Margin Management"
            description="Margin Management List"
            data={marginData?.data}
            columns={columns}
            keyField="ID"
            addbtntext="Add Margin"
            onAddBtnClick={openAddModal}
            renderFilters={filterSection}
            page={pageNum}
            sizePerPage={10}
            totalRecords={marginData?.totalRecords}
            onPageChange={(p) => setPageNum(p)}
            onSortChange={handleSortChange}
            defaultSortField={sortConfig.dataField}
            defaultSortOrder={sortConfig.sortOrder}
            showLoader={showLoader}
          />
        </Card>
        <DynamicFormModal
          isOpen={showAddMdoal?.show}
          toggle={handleManageModal}
          title={showAddMdoal.formType}
          fields={marginTabFormFields(
            dropDownData?.productTypeData,
            dropDownData?.publisherData,
            dropDownData?.dealData,
            isEditMode,
          )}
          formData={formState.values}
          errors={formState.errors}
          onChange={handleInputChange}
          onSubmit={handleSubmit}
          isEditMode={showAddMdoal.formType === "Edit Margin" ? true : false}
          showLoader={showLoader}
        />
      </Container>
    </>
  );
};

export default Margin_Management;